<template>
  <div :id="page.contacts.$path" v-if="page.contacts" :class="{'active': isActive()}">
    <div class="section">
      <div class="section__main reduced-width">
        <PageTitle :isActive="isActive()" :isAnimated="isAnimated" :class="{'static': isAnimated}" :titleValue="page.contacts.title"></PageTitle>
        <div class="contacts" :class="{'static': isAnimated}">
          <svg viewBox="0 0 320 390" width="320" height="390" xmlns="http://www.w3.org/2000/svg">
              <polygon points="0 0, 320 390, 0 390"/>
          </svg>
          <div class="cols cols_2">
            <div class="col">
              <div class="cols cols_2">
                <div class="col">
                  <div class="contacts__title" v-html="page.contacts.text_advisor_title"></div>
                </div>
                <div class="col">
                  <div class="contacts__content" v-html="page.contacts.text_advisor"></div>
                </div>
              </div>
              <div class="cols cols_2">
                <div class="col">
                  <div class="contacts__title" v-html="page.contacts.text_environmental_title"></div>
                </div>
                <div class="col">
                  <div class="contacts__content" v-html="page.contacts.text_environmental"></div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="cols cols_2">
                <div class="col">
                  <div class="contacts__title" v-html="page.contacts.text_issues_title"></div>
                </div>
                <div class="col">
                  <div class="contacts__content" v-html="page.contacts.text_issues"></div>
                </div>
              </div>
              <div class="cols cols_2">
                <div class="col">
                  <div class="contacts__title" v-html="page.contacts.text_press_title"></div>
                </div>
                <div class="col">
                  <div class="contacts__content" v-html="page.contacts.text_press"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageTitle from '@/components/PageTitle';

export default {
  name: 'contacts',
  data() {
    return {
      isAnimated: false,
    };
  },
  components: {
    PageTitle,
  },
  computed: mapGetters({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
  }),
  methods: {
    isActive() {
      const checkActive = this.currentPage === this.page.contacts.$path;
      const animationTime = (this.page.contacts.title.length * 70) + 900;
      setTimeout(() => {
        if (checkActive) {
          this.isAnimated = true;
        }
      }, animationTime);
      return checkActive;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @keyframes triangleAnimation {
    0% {
      transform: rotateX(0) rotateY(0) rotateZ(0);
    }
    25% {
      transform: rotateX(12deg) rotateY(5deg) rotateZ(3deg);
    }
    50% {
      transform: rotateX(10deg) rotateY(17deg) rotateZ(1deg);
    }
    75% {
      transform: rotateX(5deg) rotateY(11deg) rotateZ(7deg);
    }
    100% {
      transform: rotateX(1deg) rotateY(13deg) rotateZ(10deg);
    }
  }

  #contacts {
    padding-top: 20vh;
    min-height: 100vh;
    overflow: hidden;
  }

  .contacts {
    margin: 60px 0 0;
    position: relative;
    perspective: 500;

    svg {
      position: absolute;
      width: 50%;
      height: auto;
      top: -22vh;
      right: 20px;
      max-height: 64vh;
      z-index: -1;
      opacity: 0.1;
      animation: triangleAnimation 16s ease-in-out infinite alternate;
      transform-origin: center;

      polygon {
        fill: $main-color;
      }
    }

    .cols {
      .cols {
        .col {
          margin-right: 5%;
        }
      }
    }

    &__title {
      position: relative;
      left: -20px;
      opacity: 0;

      #contacts.active .contacts:not(.static) & {
        left: 0;
        opacity: 1;
        transition: all 0.8s ease-in-out 0.3s;
      }

      #contacts .contacts.static & {
        left: 0;
        opacity: 1;
      }
    }

    &__content {
      position: relative;
      left: -20px;
      opacity: 0;

      #contacts.active .contacts:not(.static) & {
        left: 0;
        opacity: 1;
        transition: all 0.8s ease-in-out 0.7s;
      }

      #contacts .contacts.static & {
        left: 0;
        opacity: 1;
      }
    }
  }

  @media (max-width: 850px) {
    #contacts {
      padding-top: 110px;
      min-height: 0;

      .contacts {
        margin: 55px 0 0;

        svg {
          display: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Contacts.vue?aa442018